import * as React from 'react';
import {Component} from 'react';
import {isValid} from '../utils/time';

interface Props {
    value: string;
    format: string;
    onUpdate?(value: string): void;
    onChange(value: string): void;
    render(props: InjectedDurationProps): JSX.Element;
    disabled?: boolean;
}
interface State {
    value: string;
}

export interface InjectedDurationProps extends State {
    placeholder: string;
    handleChange(value: string): void;
    handleEndEditing(duration: string);
}

export class TimeControl extends Component<Props, State> {
    static defaultProps = {
        value: '',
        format: 'HH:mm'
    };

    constructor(props) {
        super(props);

        this.state = {
            value: props.value
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleEndEditing = this.handleEndEditing.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value
        });
    }
    handleChange(value: string) {
        const {onChange, format} = this.props;

        if (isValid(value, format)) {
            let newValue = value;
            const oldValue = this.state.value;
            /**
             * check if type/delete NULL
             */

            if (newValue === 'N') {
                newValue = 'NULL';
            } else if (oldValue === 'NULL' && newValue === 'NUL') {
                newValue = '';
            } else if (newValue.length === 2 && oldValue.length === 1)
                newValue =
                    /**
                     * add/remove : symbol
                     */
                    `${value}:`;
            else if (newValue.length === 2 && oldValue.length === 3)
                newValue = value.substring(0, 1);
            /**
             * Add/Remove  space symbol before AM/PM
             */ else if (format !== 'HH:mm' && newValue.length === 5 && oldValue.length === 4)
                newValue = `${value} `;
            else if (format !== 'HH:mm' && newValue.length === 5 && oldValue.length === 6)
                newValue = value.substring(0, 4);
            // /**
            //  * Auto complete AM/PM
            //  * Capitalise letters
            //  */
            else if (format !== 'HH:mm' && newValue.length === 7 && oldValue.length === 6) {
                newValue = value.substring(0, 6) + value.charAt(6).toUpperCase() + 'M';
            } else if (format !== 'HH:mm' && newValue.length === 7 && oldValue.length === 8)
                newValue = value.substring(0, 6);

            this.setState({
                value: newValue
            });
            onChange && onChange(newValue);
        }
    }

    handleEndEditing() {
        const {onUpdate} = this.props;
        const {value} = this.state;
        onUpdate(value);
    }

    render() {
        const {render: Component, format} = this.props;
        const placeholder = format === 'HH:mm' ? '--:--' : '--:-- --';
        return (
            <Component
                {...this.props}
                {...this.state}
                placeholder={placeholder}
                handleChange={this.handleChange}
                handleEndEditing={this.handleEndEditing}
            />
        );
    }
}

export const withDuration = <P extends InjectedDurationProps>(
    Component: React.ComponentType<P>
) => {
    return props => {
        return <TimeControl {...props} render={p => <Component {...(p as P)} />} />;
    };
};
